export default __webpack_public_path__ + "static/tek-help-7b1bd3914fdc36edae354612d22e1a3c.png";